

















import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { PermGroup, siteAdminPermApis, InvalidParam } from '../../api';

@Component
export default class PermGroupEditDialog extends Vue {
  readonly rules = { name: { required: true } };

  @Prop() siteId!: number;
  dialogVisible = false;
  group: PermGroup | null = null;
  resolve: ((group: PermGroup) => void) | null = null;
  errors = {};

  show(group: PermGroup | null): Promise<PermGroup> {
    this.errors = {};
    if (group) {
      this.group = JSON.parse(JSON.stringify(group));
    } else {
      this.group = { name: '' } as PermGroup;
    }
    this.dialogVisible = true;
    return new Promise(resolve => {
      this.resolve = resolve;
    });
  }

  async save() {
    try {
      if (this.group) {
        const group = await siteAdminPermApis.savePermGroup(this.siteId, this.group);
        if (this.resolve) {
          this.resolve(group);
          this.resolve = null;
        }
        this.group = null;
      }
      this.dialogVisible = false;
      this.$notify.success(`保存成功`);
    } catch (e) {
      if (e instanceof InvalidParam) {
        this.errors = e.params;
      } else {
        this.$notify.error(e.message);
      }
    }
  }
}
